import {
  DemographicRequest,
  PatternsHourRequest,
  PatternsWeekdayRequest,
  ReturnRateRequest,
  TrendsDatesRequest,
  TrendsRequest,
  TrendsDatesResponse,
  TrendsResponse,
  PatternsHourDatesResponse,
  PatternsHourResponse,
  PatternsWeekdayDatesResponse,
  PatternsWeekdayResponse,
  VisitLengthDatesResponse,
  CaptureRateRequest,
  CaptureRateResponse,
  ReturnRateResponse,
  VisitLengthRequest,
  VisitLengthResponse,
  CaptureRateDatesResponse,
  DemographicDatesResponse,
  DemographicResponse,
  ReturnRateDatesResponse,
  AreaTrendsRequest,
  AreaPatternsHourRequest,
  AreaPatternsWeekdayRequest,
  AreaDemographicRequest,
  AreaTrendsResponse,
} from 'src/common-services/types/footfall-types'
import { BaseClient } from 'src/common-services/clients/base-client'

export class FootfallClient extends BaseClient {
  getTrendsDates(request: TrendsDatesRequest): Promise<TrendsDatesResponse> {
    return this.call<TrendsDatesResponse>('/footfall/trends/dates', 'GET', {
      params: { period: request.period },
    })
  }

  getTrends(request: TrendsRequest): Promise<TrendsResponse> {
    return this.call<TrendsResponse>(`/footfall/trends/${encodeURIComponent(request.venueId)}`, 'GET', {
      params: {
        start: request.start,
        end: request.end,
        period: request.period,
      },
    })
  }

  getAreaTrends(request: AreaTrendsRequest): Promise<TrendsResponse> {
    return this.call<AreaTrendsResponse>('/footfall/trends/by-area', 'POST', { data: request })
  }

  getPatternsHourDates(): Promise<PatternsHourDatesResponse> {
    return this.call<PatternsHourDatesResponse>('/footfall/patterns/hour/dates', 'GET')
  }

  getPatternsHour(request: PatternsHourRequest): Promise<PatternsHourResponse> {
    return this.call<PatternsHourResponse>(`/footfall/patterns/hour/${encodeURIComponent(request.venueId)}`, 'GET', {
      params: { start: request.start },
    })
  }

  getAreaPatternsHour(request: AreaPatternsHourRequest): Promise<PatternsHourResponse> {
    return this.call('/footfall/patterns/hour/by-area', 'POST', { data: request })
  }

  getPatternsWeekdayDates(): Promise<PatternsWeekdayDatesResponse> {
    return this.call<PatternsWeekdayDatesResponse>('/footfall/patterns/weekday/dates', 'GET')
  }

  getPatternsWeekday(request: PatternsWeekdayRequest): Promise<PatternsWeekdayResponse> {
    return this.call<PatternsWeekdayResponse>(
      `/footfall/patterns/weekday/${encodeURIComponent(request.venueId)}`,
      'GET',
      { params: { start: request.start } }
    )
  }

  getAreaPatternsWeekday(request: AreaPatternsWeekdayRequest): Promise<PatternsWeekdayResponse> {
    return this.call('/footfall/patterns/weekday/by-area', 'POST', { data: request })
  }

  getVisitLengthDates(): Promise<VisitLengthDatesResponse> {
    return this.call<VisitLengthDatesResponse>('/footfall/visit-length/dates', 'GET')
  }

  getVisitLength(request: VisitLengthRequest): Promise<VisitLengthResponse> {
    return this.call<VisitLengthResponse>(`/footfall/visit-length/${encodeURIComponent(request.venueId)}`, 'GET', {
      params: { start: request.start },
    })
  }

  getCaptureRateDates(): Promise<CaptureRateDatesResponse> {
    return this.call<CaptureRateDatesResponse>('/footfall/capture-rate/dates', 'GET')
  }

  getCaptureRate(request: CaptureRateRequest): Promise<CaptureRateResponse> {
    return this.call<CaptureRateResponse>(`/footfall/capture-rate/${encodeURIComponent(request.venueId)}`, 'GET', {
      params: { start: request.start },
    })
  }

  getReturnRateDates(): Promise<ReturnRateDatesResponse> {
    return this.call<ReturnRateDatesResponse>('/footfall/return-rate/dates', 'GET')
  }

  getReturnRate(request: ReturnRateRequest): Promise<ReturnRateResponse> {
    return this.call<ReturnRateResponse>(`/footfall/return-rate/${encodeURIComponent(request.venueId)}`, 'GET', {
      params: { start: request.start, end: request.end },
    })
  }

  getDemographicDates(): Promise<DemographicDatesResponse> {
    return this.call<DemographicDatesResponse>('/footfall/demographic/dates', 'GET')
  }

  getDemographic(request: DemographicRequest): Promise<DemographicResponse> {
    return this.call<DemographicResponse>(`/footfall/demographic/${encodeURIComponent(request.venueId)}`, 'GET', {
      params: { start: request.start },
    })
  }

  getAreaDemographic(request: AreaDemographicRequest): Promise<DemographicResponse> {
    return this.call('/footfall/demographic/by-area', 'POST', { data: request })
  }
}
